import React, { useState } from "react";
import * as Icons from "lucide-react";

// Éditeur de métiers multiples (tags). value: string[], onChange: (string[]) => void
export default function MetiersInput({ value = [], onChange, testid = "metiers" }) {
  const [draft, setDraft] = useState("");
  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (!value.some((x) => x.toLowerCase() === v.toLowerCase())) onChange([...value, v]);
    setDraft("");
  };
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));
  return (
    <div data-testid={testid}>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {value.map((m, i) => (
            <span key={i} data-testid={`${testid}-tag-${i}`} className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-sm bg-sable border border-marine/30 text-marine">
              {m}
              <button type="button" onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`} aria-label={`Retirer ${m}`} title="Retirer" className="text-bordeaux hover:text-rouge"><Icons.X size={16} /></button>
            </span>
          ))}
        </div>
      )}
      <div className="flex items-center gap-2">
        <input value={draft} onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
          data-testid={`${testid}-input`} className="inp flex-1" placeholder="Monteur vidéo, Designer…" />
        <button type="button" onClick={add} data-testid={`${testid}-add`} className="shrink-0 rounded-sm bg-marine text-white px-3 py-2 text-sm hover:bg-marine-hover transition-colors">Ajouter</button>
      </div>
    </div>
  );
}
